import { createFileRoute } from "@tanstack/react-router";
import { ComponentSizeTest } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute(
  "/demo/design-system/tests/component-size",
)({
  component: ComponentSizeTest,
});
